import api from '../helpers/apiHelper.js';
import { errorToast, successToast } from '../helpers/projectHelper.js';
import {
	LOGIN_API_ROOT,
	VISITOR_REGISTRATION_API,
	VISITORS_API,
	VISITOR_ACCEPT_API,
	VISITOR_REJECT_API,
	VISITOR_SCAN_API,
	VISITOR_STATS_API,
	ITIKAAF_SEND_OTP_API,
	ITIKAAF_VERIFY_OTP_API,
	ITIKAAF_EVENTS_API,
	ITIKAAF_EVENT_REGISTER_API,
	ITIKAAF_CONFIRM_REGISTRATION_API,
	ITIKAAF_REJECT_REGISTRATION_API,
	ITIKAAF_CONFIRM_REGISTRATION_AS_NAFIL_API,
	USER_REGISTER_API,
} from '../config/constants/apiConstant.js';
import { getVisitorLists } from '../redux/slicers/adminSlice.js';
import { getItikaafEventLists } from '../redux/slicers/eventSlice.js';
import Swal from 'sweetalert2';

// Public Visitor Registration API
export const visitorRegistrationApi =
	(formData, resetForm, setLoadingbtn) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.post(VISITOR_REGISTRATION_API)
			.data(formData)
			.success((a) => {
				const { message: msg = '' } = a;
				setLoadingbtn(false);
				if (a.statusCode === 201) {
					resetForm();
					Swal.fire({
						title: 'Thank you!',
						text: `${msg} Your Registration ID: ${a.data?.regId}`,
						icon: 'success',
						allowOutsideClick: false,
						preConfirm: () => {
							window.location.reload();
						},
					});
				} else {
					Swal.fire({
						title: 'Validation Missing!',
						text: msg,
						icon: 'warning',
						allowOutsideClick: false,
					});
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				setLoadingbtn(false);
				Swal.fire('Error!', msg, 'error');
			})
			.send(() => {
				setLoadingbtn(false);
			});
	};

// Get All Visitors (Protected)
export const getVisitorsListApi =
	(SIZE, setListsize, page, setLoading, filters = {}) =>
		(dispatch) => {
			const params = new URLSearchParams();
			params.append('page', page);
			params.append('limit', SIZE);

			if (filters.search) params.append('search', filters.search);
			if (filters.status) params.append('status', filters.status);
			if (filters.isScanned !== undefined)
				params.append('isScanned', filters.isScanned);
			if (filters.startDate) params.append('startDate', filters.startDate);
			if (filters.endDate) params.append('endDate', filters.endDate);
			if (filters.sortBy) params.append('sortBy', filters.sortBy);

			const url = `${VISITORS_API}?${params.toString()}`;

			api()
				.root(LOGIN_API_ROOT)
				.get(url)
				.success((a) => {
					setLoading && setLoading(false);
					if (a.statusCode === 200) {
						setListsize(a?.data?.totalCounts || 0);
						dispatch(getVisitorLists(a?.data?.data || []));
					} else {
						dispatch(getVisitorLists([]));
					}
				})
				.error((e) => {
					const { message: msg = '' } = e;
					errorToast(msg);
					dispatch(getVisitorLists([]));
					setLoading && setLoading(false);
				})
				.send(() => {
					setLoading && setLoading(false);
				});
		};

// Get Single Visitor (Protected)
export const getSingleVisitorApi =
	(visitorId, setVisitor, setLoading) => (dispatch) => {
		setLoading && setLoading(true);
		const url = `${VISITORS_API}/${visitorId}`;

		api()
			.root(LOGIN_API_ROOT)
			.get(url)
			.success((a) => {
				setLoading && setLoading(false);
				if (a.statusCode === 200) {
					setVisitor(a?.data);
				} else {
					setVisitor(null);
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
				setVisitor(null);
				setLoading && setLoading(false);
			})
			.send(() => {
				setLoading && setLoading(false);
			});
	};

// Accept Visitor (Protected)
export const acceptVisitorApi =
	(visitorId, getVisitorsList, setLoadingBtn) => (dispatch) => {
		setLoadingBtn && setLoadingBtn(true);
		api()
			.root(LOGIN_API_ROOT)
			.post(`${VISITOR_ACCEPT_API}/${visitorId}/accept`)
			.data({})
			.success((a) => {
				setLoadingBtn && setLoadingBtn(false);
				if (a.statusCode === 200) {
					successToast(a.message);
					getVisitorsList && getVisitorsList();
				} else {
					errorToast(a.message);
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				errorToast(msg);
				setLoadingBtn && setLoadingBtn(false);
			})
			.send(() => {
				setLoadingBtn && setLoadingBtn(false);
			});
	};

// Reject Visitor (Protected)
export const rejectVisitorApi =
	(visitorId, rejectionReason, getVisitorsList, setLoadingBtn) =>
		(dispatch) => {
			setLoadingBtn && setLoadingBtn(true);
			api()
				.root(LOGIN_API_ROOT)
				.post(`${VISITOR_REJECT_API}/${visitorId}/reject`)
				.data({ rejectionReason })
				.success((a) => {
					setLoadingBtn && setLoadingBtn(false);
					if (a.statusCode === 200) {
						successToast(a.message);
						getVisitorsList && getVisitorsList();
					} else {
						errorToast(a.message);
					}
				})
				.error((e) => {
					const { message: msg = '' } = e;
					errorToast(msg);
					setLoadingBtn && setLoadingBtn(false);
				})
				.send(() => {
					setLoadingBtn && setLoadingBtn(false);
				});
		};

// Scan Visitor QR Code (Protected)
export const scanVisitorQRApi =
	(identifier, setScanResult, setLoading, isManualEntry = false) =>
		(dispatch) => {
			setLoading && setLoading(true);

			// Prepare data based on scan type
			const data = isManualEntry ? { regId: identifier } : { _id: identifier };

			api()
				.root(LOGIN_API_ROOT)
				.post(VISITOR_SCAN_API)
				.data(data)
				.success((a) => {
					setLoading && setLoading(false);
					if (a.statusCode === 200) {
						setScanResult && setScanResult(a.data);
						successToast(a.message);
					} else {
						errorToast(a.message);
						setScanResult && setScanResult(null);
					}
				})
				.error((e) => {
					const { message: msg = '' } = e;
					errorToast(msg);
					setScanResult && setScanResult(null);
					setLoading && setLoading(false);
				})
				.send(() => {
					setLoading && setLoading(false);
				});
		};

// Get Visitor Statistics (Protected)
export const getVisitorStatsApi = (setStats, setLoading) => (dispatch) => {
	setLoading && setLoading(true);
	api()
		.root(LOGIN_API_ROOT)
		.get(VISITOR_STATS_API)
		.success((a) => {
			setLoading && setLoading(false);
			if (a.statusCode === 200) {
				setStats && setStats(a.data);
			} else {
				setStats && setStats(null);
				errorToast(a.message);
			}
		})
		.error((e) => {
			const { message: msg = '' } = e;
			errorToast(msg);
			setStats && setStats(null);
			setLoading && setLoading(false);
		})
		.send(() => {
			setLoading && setLoading(false);
		});
};

// ============================================
// I'TIKAF EVENT REGISTRATION APIs (OTP-BASED)
// ============================================

// Send OTP to phone number
export const sendOtpApi = (phoneNumber, setLoading, setOtpSent) => (dispatch) => {
	setLoading && setLoading(true);
	api()
		.root(LOGIN_API_ROOT)
		.post(ITIKAAF_SEND_OTP_API)
		.data({ phoneNumber })
		.success((a) => {
			setLoading && setLoading(false);
			if (a.statusCode === 200 || a.success) {
				setOtpSent && setOtpSent(true);
				successToast(a.message || 'OTP sent successfully');
			} else {
				errorToast(a.message || 'Failed to send OTP');
			}
		})
		.error((e) => {
			const { message: msg = '' } = e;
			setLoading && setLoading(false);
			errorToast(msg || 'Error sending OTP');
		})
		.send(() => {
			setLoading && setLoading(false);
		});
};

// Verify OTP and get user details if exists
export const verifyOtpApi =
	(phoneNumber, otp, setLoading, setVerified, setUserData, eventId, onRegistration) => (dispatch) => {
		setLoading && setLoading(true);

		const requestBody = { phoneNumber, otp };
		if (eventId) requestBody.eventId = eventId;

		api()
			.root(LOGIN_API_ROOT)
			.post(ITIKAAF_VERIFY_OTP_API)
			.data(requestBody)
			.success((a) => {
				setLoading && setLoading(false);
				if ((a.statusCode === 200 || a.success) && a.data?.verified) {
					// Store verification token and phone
					localStorage.setItem('verificationToken', a.data.verificationToken);
					localStorage.setItem('verifiedPhone', a.data.phoneNumber);

					setVerified && setVerified(true);
					successToast(a.message || 'OTP verified successfully');

					// If user exists, set user data for pre-filling
					if (a.data.userExists && a.data.user) {
						setUserData && setUserData(a.data.user);
					} else {
						setUserData && setUserData(null);
					}

					// Pass registration status back if callback provided
					// registration is undefined (key absent), null (new user), or an object
					if (onRegistration) {
						onRegistration('registration' in a.data ? a.data.registration : undefined);
					}
				} else {
					errorToast(a.message || 'Invalid OTP');
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				setLoading && setLoading(false);
				errorToast(msg || 'OTP verification failed');
			})
			.send(() => {
				setLoading && setLoading(false);
			});
	};

// Get all available I'tikaf events
export const getItikaafEventsApi = (setLoading) => (dispatch) => {
	setLoading && setLoading(true);
	api()
		.root(LOGIN_API_ROOT)
		.get(ITIKAAF_EVENTS_API)
		.success((a) => {
			setLoading && setLoading(false);
			if (a.statusCode === 200 && a.data) {
				dispatch(getItikaafEventLists(a.data));
			} else {
				dispatch(getItikaafEventLists([]));
			}
		})
		.error((e) => {
			const { message: msg = '' } = e;
			setLoading && setLoading(false);
			errorToast(msg || 'Failed to load events');
			dispatch(getItikaafEventLists([]));
		})
		.send(() => {
			setLoading && setLoading(false);
		});
};

// Get specific I'tikaf event by ID
export const getEventByIdApi = (eventId, setLoading, onSuccess, onError) => {
	setLoading && setLoading(true);
	api()
		.root(LOGIN_API_ROOT)
		.get(`${ITIKAAF_EVENTS_API}/${eventId}`)
		.success((a) => {
			setLoading && setLoading(false);
			if (a.statusCode === 200 && a.data) {
				onSuccess && onSuccess(a.data);
			} else {
				onError && onError('Event not found');
			}
		})
		.error((e) => {
			const { message: msg = '' } = e;
			setLoading && setLoading(false);
			onError && onError(msg || 'Failed to load event details');
		})
		.send(() => {
			setLoading && setLoading(false);
		});
};

// Register for specific event
export const registerForEventApi =
	(eventId, formData, resetForm, navigate, setLoadingbtn) => (dispatch) => {
		setLoadingbtn && setLoadingbtn(true);

		const verificationToken = localStorage.getItem('verificationToken');
		const phoneNumber = localStorage.getItem('verifiedPhone');

		const payload = {
			...formData,
			phoneNumber,
			verificationToken,
		};

		api()
			.root(LOGIN_API_ROOT)
			.post(`${ITIKAAF_EVENT_REGISTER_API}/${eventId}/register`)
			.data(payload)
			.success((a) => {
				const { message: msg = '' } = a;
				setLoadingbtn && setLoadingbtn(false);
				if (a.statusCode === 201 || a.success) {
					// Clear verification token after successful registration
					localStorage.removeItem('verificationToken');
					localStorage.removeItem('verifiedPhone');

					resetForm && resetForm();
					Swal.fire({
						title: 'Registration Submitted!',
						html: `
							<p>${msg}</p>
							<p><strong>Status:</strong> PENDING</p>
							<p>You will be notified once admin reviews your registration.</p>
						`,
						icon: 'success',
						allowOutsideClick: false,
						preConfirm: () => {
							navigate && navigate('/');
						},
					});
				} else {
					Swal.fire({
						title: 'Registration Failed!',
						text: msg,
						icon: 'warning',
						allowOutsideClick: false,
					});
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				setLoadingbtn && setLoadingbtn(false);

				// Check if token expired
				if (msg.includes('expired') || msg.includes('Invalid') || msg.includes('token')) {
					localStorage.removeItem('verificationToken');
					localStorage.removeItem('verifiedPhone');
					Swal.fire({
						title: 'Verification Expired!',
						text: 'Your verification has expired. Please verify your phone number again.',
						icon: 'error',
						allowOutsideClick: false,
						preConfirm: () => {
							window.location.reload();
						},
					});
				} else {
					Swal.fire('Error!', msg, 'error');
				}
			})
			.send(() => {
				setLoadingbtn && setLoadingbtn(false);
			});
	};

// Public API - Get minimal info to render the confirmation page (status, allowConfirmAsNafil)
export const getConfirmationPageInfoApi =
	(registrationId, setLoading, onSuccess, onFailure) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.get(`${ITIKAAF_CONFIRM_REGISTRATION_API}/${registrationId}`)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200) {
					onSuccess && onSuccess(response.data);
				} else {
					onFailure && onFailure(response);
				}
			})
			.error((e) => {
				setLoading && setLoading(false);
				onFailure && onFailure(e);
			})
			.send(() => {
				setLoading && setLoading(false);
			});
	};

// Public API - Confirm Registration
export const confirmRegistrationApi =
	(registrationId, setLoading, onSuccess, onFailure) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.post(`${ITIKAAF_CONFIRM_REGISTRATION_API}/${registrationId}`)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200) {
					successToast(response.message || 'Participation confirmed successfully');
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(response.message || 'Failed to confirm participation');
					onFailure && onFailure(response);
				}
			})
			.error((e) => {
				const { message: msg = 'Something went wrong' } = e;
				setLoading && setLoading(false);
				errorToast(msg);
				onFailure && onFailure(e);
			})
			.send(() => {
				setLoading && setLoading(false);
			});
	};

// Public API - Confirm Registration as Nafil
export const confirmRegistrationAsNafilApi =
	(registrationId, setLoading, onSuccess, onFailure) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.post(`${ITIKAAF_CONFIRM_REGISTRATION_AS_NAFIL_API}/${registrationId}`)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200) {
					successToast(response.message || 'Your participation has been confirmed as Nafil.');
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(response.message || 'Failed to confirm participation as Nafil');
					onFailure && onFailure(response);
				}
			})
			.error((e) => {
				const { message: msg = 'Something went wrong' } = e;
				setLoading && setLoading(false);
				errorToast(msg);
				onFailure && onFailure(e);
			})
			.send(() => {
				setLoading && setLoading(false);
			});
	};

// Public API - Reject Registration
export const rejectRegistrationApi =
	(registrationId, setLoading, onSuccess, onFailure) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.post(`${ITIKAAF_REJECT_REGISTRATION_API}/${registrationId}`)
			.success((response) => {
				setLoading && setLoading(false);
				if (response.statusCode === 200) {
					successToast(response.message || 'Your response has been recorded');
					onSuccess && onSuccess(response.data);
				} else {
					errorToast(response.message || 'Failed to process your response');
					onFailure && onFailure(response);
				}
			})
			.error((e) => {
				const { message: msg = 'Something went wrong' } = e;
				setLoading && setLoading(false);
				errorToast(msg);
				onFailure && onFailure(e);
			})
			.send(() => {
				setLoading && setLoading(false);
			});
	};

export const userRegisterApi =
	(formData, resetForm, setLoadingbtn) => (dispatch) => {
		api()
			.root(LOGIN_API_ROOT)
			.post(USER_REGISTER_API)
			.data(formData)
			.success((a) => {
				const { message: msg = '' } = a;
				setLoadingbtn(false);
				if (a.statusCode === 201) {
					resetForm();
					Swal.fire({
						title: 'Registered Successfully!',
						text: `${msg}${a.data?.userid ? ' Your User ID: ' + a.data.userid : ''}`,
						icon: 'success',
						allowOutsideClick: false,
						preConfirm: () => {
							window.location.reload();
						},
					});
				} else {
					Swal.fire({
						title: 'Registration Failed',
						text: msg,
						icon: 'warning',
						allowOutsideClick: false,
					});
				}
			})
			.error((e) => {
				const { message: msg = '' } = e;
				setLoadingbtn(false);
				errorToast(msg);
			})
			.send(() => { });
	};

